import { clockOf, phaseOf } from '../labState';
import { Btn, Card, Empty, Pill } from '../ui';

const GameList = ({ games, selectedId, onSelect, onDeleteAll, loading }) => (
  <Card
    title="Mock games"
    subtitle={loading ? 'Loading…' : `${games.length} on this environment`}
    right={
      <Btn variant="danger" disabled={!games.length} onClick={onDeleteAll}>
        Delete all
      </Btn>
    }
  >
    {!games.length && !loading && <Empty>No mock games yet. Create one above.</Empty>}
    <ul className="flex flex-col gap-1.5">
      {games.map((game) => {
        const phase = phaseOf(game);
        const selected = game._id === selectedId;
        return (
          <li key={game._id}>
            <button
              type="button"
              onClick={() => onSelect(game._id)}
              aria-current={selected ? 'true' : undefined}
              className={`w-full text-left rounded-lg border border-solid px-3 py-2 transition-colors ${
                selected
                  ? 'border-[#6366F1] bg-[#EEF2FF]'
                  : 'border-[#E2E8F0] bg-white hover:border-[#94A3B8]'
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-[13px] font-semibold text-[#0F172A] truncate">
                  {game.homeName} <span className="text-[#64748B] font-normal">vs</span>{' '}
                  {game.awayName}
                </span>
                <span className="text-[13px] font-semibold tabular-nums text-[#0F172A]">
                  {game.score?.home ?? 0}–{game.score?.away ?? 0}
                </span>
              </div>
              <div className="flex items-center gap-2 mt-1">
                <Pill tone={phase.tone}>{phase.label}</Pill>
                <span className="text-[12px] text-[#64748B] tabular-nums">{clockOf(game)}</span>
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  </Card>
);

export default GameList;
